<template>
  <div class="tariffs-small">
    <collapse-footered class="tariffs_tablet_list_item">
      <template #head>
        <div class="tariffs_tablet_list_item_caption">
          <h3 class="uppercase ta-center">
            <b>Base</b>
          </h3>
        </div>
      </template>
      <template #content>
        <div class="tariffs_tablet_content">
          <div v-for="(item, i) in base" :key="'base' + i" class="tariffs_tablet_content__item">
            <img :src="item.ico" alt="" class="icon" width="40" />
            <div class="tariffs_tablet-text">
              {{ item.text }}
              <v-question v-if="item.extra" :content="item.extra" :small="true" />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="tariffs_tablet_footer">
          <button class="button button-primary button-sm" @click="$emit('callback')">
            {{ translates.btn }}
          </button>
        </div>
      </template>
    </collapse-footered>
    <collapse-footered class="tariffs_tablet_list_item">
      <template #head>
        <div class="tariffs_tablet_list_item_caption">
          <h3 class="uppercase ta-center">
            <b>Optimum</b>
          </h3>
        </div>
      </template>
      <template #content>
        <p class="tariffs_tablet_content">
          {{ translates.opt }}
          <b>Base</b>
          {{ translates.opt2 }}
        </p>
        <div class="tariffs_tablet_content">
          <div v-for="(item, i) in standard" :key="'base' + i" class="tariffs_tablet_content__item">
            <img :src="item.ico" alt="" class="icon" width="40" />
            <div class="tariffs_tablet-text">
              {{ item.text }}
              <v-question v-if="item.extra" :content="item.extra" :small="true" />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="tariffs_tablet_footer">
          <button class="button button-primary button-sm" @click="$emit('callback')">
            {{ translates.btn }}
          </button>
        </div>
      </template>
    </collapse-footered>
    <collapse-footered class="tariffs_tablet_list_item">
      <template #head>
        <div class="tariffs_tablet_list_item_caption">
          <h3 class="uppercase ta-center">
            <b>Smart</b>
          </h3>
        </div>
      </template>
      <template #content>
        <p class="tariffs_tablet_content">
          {{ translates.opt }}
          <b>Optimum</b>
          {{ translates.opt2 }}
        </p>
        <div class="tariffs_tablet_content">
          <div v-for="(item, i) in premium" :key="'base' + i" class="tariffs_tablet_content__item">
            <img :src="item.ico" alt="" class="icon" width="40" />
            <div class="tariffs_tablet-text">
              {{ item.text }}
              <v-question v-if="item.extra" :content="item.extra" :small="true" />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="tariffs_tablet_footer">
          <button class="button button-primary button-sm" @click="$emit('callback')">
            {{ translates.btn }}
          </button>
        </div>
      </template>
    </collapse-footered>
  </div>
</template>
<script>
import VQuestion from 'COMMON_COMPONENTS/VQuestion.vue';
import CollapseFootered from './CollapseFootered.vue';

export default {
  name: 'TariffsSmall',
  components: {CollapseFootered, VQuestion},
  props: {
    translates: {
      type: Object,
    },
    lines: {
      type: Array,
    },
  },
  computed: {
    base() {
      return this.lines.filter((el) => el.available.includes('base'));
    },
    standard() {
      return this.lines.filter((el) => {
        return el.available.includes('optimum') && !el.available.includes('base');
      });
    },
    premium() {
      return this.lines.filter((el) => {
        return el.available.includes('smart') && !el.available.includes('optimum');
      });
    },
  },
};
</script>
<style>
.tariffs_tablet-text {
  font-size: 0.86rem;
  line-height: 1.33;
}
.tariffs-small {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  align-items: start;
}
@media (--viewport-planshet) {
  .tariffs-small {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (--viewport-desktop-small) {
  .tariffs-small {
    display: none;
  }
}
.tariffs_tablet_content__item {
  display: flex;
  align-items: center;
  padding: 10px 10px 10px 0;
  border-radius: 5px;
}
.tariffs_tablet_content__item .icon {
  margin-right: 10px;
}
.tariffs_tablet_content {
  padding: 0 12px 15px;
}
.tariffs_tablet_content__item:nth-child(odd) {
  background: var(--mid-grey);
}
.tariffs_tablet_footer {
  text-align: center;
}
</style>
